import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcExpand = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.8669 3.58073C11.8669 3.21254 12.1654 2.91406 12.5336 2.91406H16.9171C17.2853 2.91406 17.5837 3.21254 17.5837 3.58073V7.9642C17.5837 8.33239 17.2853 8.63087 16.9171 8.63087C16.5489 8.63087 16.2504 8.33239 16.2504 7.9642V5.1902L11.9091 9.53148C11.6488 9.79183 11.2267 9.79183 10.9663 9.53148C10.706 9.27113 10.706 8.84902 10.9663 8.58867L15.3076 4.2474H12.5336C12.1654 4.2474 11.8669 3.94892 11.8669 3.58073ZM9.53441 10.963C9.79476 11.2233 9.79476 11.6454 9.53441 11.9058L5.19313 16.247H7.96713C8.33532 16.247 8.6338 16.5455 8.6338 16.9137C8.6338 17.2819 8.33532 17.5804 7.96713 17.5804H3.58366C3.21547 17.5804 2.91699 17.2819 2.91699 16.9137V12.5302C2.91699 12.162 3.21547 11.8636 3.58366 11.8636C3.95185 11.8636 4.25033 12.162 4.25033 12.5302V15.3042L8.5916 10.963C8.85195 10.7026 9.27406 10.7026 9.53441 10.963Z",
		fill: "#A9AFBB"
	})
});
export default SvgIcExpand;
